// This file maps state to stores, and also exposes a fetchData function to fetch all the data needed to render the smart component
import GraphStore from '@src/stores/GraphStore';
import CommonStore from '@src/stores/CommonStore';
import { getSubstoryGraph } from 'actions/BotActions';
import { EventTypes } from 'constants/MogamboConstants';

/**
 * These are the stores the container will subscribe to, the getStateFromStores()
 * below runs again if the stores mentioned here emit a change
 * @type {Array}
 */
export const listenToStores = [GraphStore, CommonStore];

/**
 * Maps objects from the store to the local container
 * We fetch different values from the various stores and then assign them
 * here so that they're available as props to the container component
 * @return {[type]} [description]
 */
export function getStateFromStores() {
  const metatags = CommonStore.getMetaTags();
  return {
    // meta info
    meta: metatags,
    domain: metatags.domain,
    story: metatags.story,
    subStory: metatags.subStory,
    connection: metatags.connection,
    step: metatags.step,
    graph: GraphStore.getGraph(),
    graphLoading: GraphStore.getGraphLoading(),
    allSteps: GraphStore.getAllSteps(),
    setDroppable: GraphStore.setDroppable,
    currentLanguage: CommonStore.getCurrentLanguage(),
  };
}

/**
 * These functions are exported from here rather than being imported directly
 * into the containers to keep a proper separation and maintain the ability
 * to refactor easily later if needed. All the functions are then available as
 * maps.*
 */
export {
  navToStep,
  navToNewStep,
  navToNodeSubMenu,
  navToConnectionSubMenu,
  setStepConnections,
  navToCodeStep,
  navToDynamicStep,
} from 'actions/SubstoryActions';

/**
 * Add a listener to listen to a particular store event.
 * @param {Function} callback [description]
 */
export function addGraphUpdateListener(callback) {
  CommonStore.addSingleChangeListener(EventTypes.UPDATE_GRAPH, callback);
  GraphStore.addSingleChangeListener(EventTypes.UPDATE_GRAPH, callback);
}
export function addGraphShallowUpdateListener(callback) {
  GraphStore.addSingleChangeListener(EventTypes.SHALLOW_UPDATE_GRAPH, callback);
}

/**
 * Remove the listener (called usually while unmounting a component)
 * @param {Function} callback [description]
 */
export function removeOnGraphUpdateListener(callback) {
  CommonStore.removeSingleChangeListener(EventTypes.UPDATE_GRAPH, callback);
  GraphStore.removeSingleChangeListener(EventTypes.UPDATE_GRAPH, callback);
}
export function removeGraphShallowUpdateListener(callback) {
  GraphStore.removeSingleChangeListener(
    EventTypes.SHALLOW_UPDATE_GRAPH,
    callback
  );
}

/**
 * Fetch the data for the graph
 * @param  {[type]}   storyId  [description]
 * @param  {Function} callback [description]
 * @return {[type]}            [description]
 */
export function fetchGraph(storyId, callback) {
  getSubstoryGraph(storyId, callback);
}
